import { RouteObject } from 'react-router-dom';
import LogsView from '../components/LogsView';

const routes: RouteObject[] = [
  {
    path: 'logs',
    element: <LogsView />,
  },
];

export default routes; 